/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { withClient } from 'fierry/react';


export default withClient(class
{
  constructor ({ config, navigation, dispatch, data })
  {
    this.config = config;
    this.navigation = navigation;
    this.dispatch = dispatch;
    this.data = data;
  }


  isDimming ()
  {
    return this.config.dimming;
  }


  isPannable ()
  {
    return this.config.pannable;
  }


  isGroupEmphasis ()
  {
    return this.config.groupEmphasis;
  }


  onSelect (zone, hex)
  {
    return this.config.selection.onSelect(zone, hex, this);
  }


  isSelected (zoneData)
  {
    return this.config.selection.isSelected(zoneData, this);
  }


});
